// FAQ Accordion - works on all pages
$(document).ready(function () {
	if (!$(".faq-accordion").length) return;

	$(document).on("click", ".faq-accordion-header", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var $this = $(this);
		var $content = $this.next(".faq-accordion-content");
		var $item = $this.parent(".faq-accordion-item");
		var isActive = $item.hasClass("active");

		$(".faq-accordion-item").removeClass("active");
		$(".faq-accordion-header").removeClass("active");
		$(".faq-accordion-content").removeClass("active");

		if (!isActive) {
			$item.addClass("active");
			$this.addClass("active");
			$content.addClass("active");
		}
	});
});
